module.exports = __webpack_public_path__ + "static/media/guides.036ab4f2.svg";